import { render, staticRenderFns } from "./index.v2.vue?vue&type=template&id=203b64f5&scoped=true&"
import script from "./index.v2.vue?vue&type=script&lang=js&"
export * from "./index.v2.vue?vue&type=script&lang=js&"
import style0 from "./index.v2.vue?vue&type=style&index=0&id=203b64f5&lang=scss&scoped=true&"
import style1 from "./index.v2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203b64f5",
  null
  
)

export default component.exports